import OrganizationStore from './OrganizationStore';
import OrganizationsStoreAll from './OrganizationsStoreAll';
import OrganizationsStore from './OrganizationsStore';

export default {
    organizationsStore: new OrganizationsStore(),
    organizationStore: new OrganizationStore(),
    organizationsStoreAll: new OrganizationsStoreAll()
};
